module.exports = __webpack_public_path__ + "media/images/ui__arrowUp-d2ae78d34867d5d3116d39f7a6114445.png";